// 引入axios方法
import { fun_PostAction } from "@/api/index";
// 引入加密方法
import "@/utils/security.js";
// 引入附件上传页面
import CorpPictureinfor from "@/views/page/components/pictureinfor/index.vue";
export default {
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 处理标识 默认为忘记密码
      clbs: "m",
      // 操作标志
      controllerFlg: null,
      // 申诉表ID
      ssId: null,
      // 加密key
      key: null,
      // 加密提交值
      code: null,
      // tab切换
      activeName: "1",
      count: 10,
      flag: false,
      regShow: true,
      isClick: false,
      timer: null,
      licensePathFile: null,
      address: null,
      photoName: "",
      codeImgSrc: null,
      form: {
        mYhlx: null, // 用户类型
        mYhmc: null, // 登录名称
        mLxrdzyx: null, // 联系人电子邮箱
        jCorpName: null, // 企业信息
        jCorpCode: null, // 社会信用代码
        jLicenseNum: null, // 工商营业执照注册号
        jLegalMan: null, // 法定代表人姓名
        jIdCardTypeNum: null, // 法定代表人证件类型
        jLegalManIdCard: null, // 法定代表人证件号码
        jLinkMan: null, // 姓名
        jLinkEmail: null, // 邮箱
        jLinkPhone: null, // 手机号码
        zPersonName: null, // 姓名
        zIdCardTypeNum: null, // 证件类型
        zIdCard: null, // 证件号码
        zLinkMan: null, // 姓名
        zLinkEmail: null, // 邮箱
        zLinkPhone: null, // 手机号码
        mimeCode: null, // 验证码
        ssId: null // 申诉ID
      },
      errRules: {
        mYhlx: null, // 用户类型
        mYhmc: null, // 登录名称
        mLxrdzyx: null, // 联系人电子邮箱
        jCorpName: null, // 企业信息
        jCorpCode: null, // 社会信用代码
        jLicenseNum: null, // 工商营业执照注册号
        jLegalMan: null, // 法定代表人姓名
        jIdCardTypeNum: null, // 法定代表人证件类型
        jLegalManIdCard: null, // 法定代表人证件号码
        jLinkMan: null, // 姓名
        jLinkEmail: null, // 邮箱
        jLinkPhone: null, // 手机号码
        zPersonName: null, // 姓名
        zIdCardTypeNum: null, // 证件类型
        zIdCard: null, // 证件号码
        zLinkMan: null, // 姓名
        zLinkEmail: null, // 邮箱
        zLinkPhone: null, // 手机号码
        mimeCode: null, // 验证码
        ssId: null // 申诉ID
      },
      formConfigList: [
        {
          label: "用户类型",
          value: "mYhlx",
          type: "slot",
          slotName: "mYhlx",
          required: true,
          clearable: true,
          multipleValue: true,
          rule: {
            required: true,
            message: "请选择用户类型",
            trigger: "blur"
          }
        },
        {
          label: "登录名",
          value: "mYhmc",
          type: "input",
          placeholder: "请填写",
          required: true,
          rule: {
            required: true,
            message: "请输入登录名",
            trigger: "blur"
          }
        },
        {
          label: "联系人电子邮箱",
          value: "mLxrdzyx",
          maxlength: 100,
          type: "input",
          placeholder: "请填写",
          required: false,
          rule: [
            {
              required: true,
              message: "请输入邮箱",
              trigger: "blur"
            },
            {
              pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
              message: "请输入格式正确的邮箱"
            }
          ]
        },
        {
          label: "验证码",
          value: "mimeCode",
          type: "slot",
          slotName: "mimeCode",
          required: true,
          rule: {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        },
        {
          type: "slot",
          slotName: "btn"
        }
      ],
      // 用户类型选择数据
      options: [
        {
          label: "...",
          value: ""
        },
        {
          label: "企业（市场主体）",
          value: "201508061647340018"
        },
        {
          label: "项目负责人",
          value: "201508061647510026"
        }
      ],
      pickerOptions: {
        disabledDate(time) {
          // 设置可选择的日期为今天之后的一个月内
          let curDate = new Date().getTime();
          let day = 24 * 60 * 60 * 1000;
          let dateRegion = curDate - day;
          return time.getTime() < dateRegion;
        }
      }
    };
  },

  // 注册组件
  components: {
    // 附件上传一览
    CorpPictureinfor
  },

  // 模板编译完成
  mounted() {
    // 调用验证码方法
    this.fun_GetCode();
    // 获取加密key
    this.fun_GetRSAKey();
  },
  methods: {
    /**
     * 获取验证码接口
     * @author 滕威
     */
    fun_GetCode() {
      // 获取随机数
      this.form.t = new Date().getTime() + Math.random();
      // 获取验证码
      this.codeImgSrc = `/brs-server/mime?t=${this.form.t}` + "&flag=0";
    },
    /**
     * 下拉框选择事件
     * @params e 选择的value值
     * @author 滕威
     */
    fun_GetSelectVal(e, val) {
      // 遍历查询表单对象
      for (const key in this.form) {
        // 判断key和val是否相同
        if (key == val) {
          // 相同则复制给表单
          this.form[key] = e;
        }
      }
    },
    /**
     * 获取加密key接口
     * @author 滕威
     */
    fun_GetRSAKey() {
      // 调用获取加密参数接口
      fun_PostAction("/getRSAKey").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(
            data.exponent,
            "",
            data.modulus
          );
        }
      });
    },
    /**
     * @author 滕威
     * @description 去登录
     */
    fun_Pass() {
      clearInterval(this.time);
      this.$router.push({ path: "/" });
    },
    /**
     * tab切换
     */
    fun_HandleClick(tab) {
      // 如果是附件上传修改时
      if (this.controllerFlg == "update") {
        // 提示请求失败的信息
        this.$message.error("不能切换，请先将附件上传完提交！");
        return;
      }
      this.activeName = tab.name;
      // 判断点击
      if (tab.name === "1") {
        // 密码找回
        // 处理标识赋值
        this.clbs = "m";
        // 表单显示
        this.formConfigList = [
          {
            label: "用户类型",
            value: "mYhlx",
            type: "slot",
            slotName: "mYhlx",
            required: true,
            clearable: true,
            multipleValue: true,
            rule: {
              required: true,
              message: "请选择用户类型",
              trigger: "blur"
            }
          },
          {
            label: "登录名",
            value: "mYhmc",
            type: "input",
            placeholder: "请填写",
            required: true,
            rule: {
              required: true,
              message: "请输入登录名",
              trigger: "blur"
            }
          },
          {
            label: "联系人电子邮箱",
            value: "mLxrdzyx",
            maxlength: 100,
            type: "input",
            placeholder: "请填写",
            required: false,
            rule: [
              {
                required: true,
                message: "请输入邮箱",
                trigger: "blur"
              },
              {
                pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                message: "请输入格式正确的邮箱"
              }
            ]
          },
          {
            label: "验证码",
            value: "mimeCode",
            type: "slot",
            slotName: "mimeCode",
            required: true,
            rule: {
              required: true,
              message: "请输入验证码",
              trigger: "blur"
            }
          },
          {
            type: "slot",
            slotName: "btn"
          }
        ];
        // 清除表单验证和数据
        this.$refs.form.$refs.enInform.resetFields();
      } else if (tab.name === "2") {
        // 企业申诉
        // 处理标识赋值
        this.clbs = "j";
        // 表单显示
        this.formConfigList = [
          {
            label: "企业信息",
            class: "label"
          },
          {
            label: "企业名称",
            value: "jCorpName",
            type: "input",
            maxlength: 20,
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入企业名称",
                trigger: "blur"
              }
            ]
          },
          {
            label: "社会信用代码",
            value: "jCorpCode",
            type: "input",
            maxlength: 20,
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入统一社会信用代码",
                trigger: "blur"
              },
              {
                pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
                message: "请输入正确的社会信用代码"
              }
            ]
          },
          {
            label: "工商营业执照注册号",
            value: "jLicenseNum",
            type: "input",
            placeholder: "请填写"
          },
          {
            label: "法定代表人姓名",
            value: "jLegalMan",
            type: "input",
            maxlength: 25,
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入法定代表人姓名",
                trigger: "blur"
              }
            ]
          },
          {
            label: "法定代表人证件类型",
            value: "jIdCardTypeNum",
            type: "select",
            placeholder: "请选择",
            required: true,
            rule: {
              required: true,
              message: "请选择法定代表人证件类型",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507052149470004"
            }
          },
          {
            label: "法定代表人证件号码",
            value: "jLegalManIdCard",
            type: "input",
            maxlength: 25,
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入法定代表人证件号码",
                trigger: "blur"
              }
            ]
          },
          {
            label: "申诉人信息",
            class: "label"
          },
          {
            label: "姓名",
            value: "jLinkMan",
            type: "input",
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入姓名",
                trigger: "blur"
              },
              { pattern: /^[\u4e00-\u9fa5]{0,}$/, message: "请输入中文" }
            ]
          },
          {
            label: "邮箱",
            value: "jLinkEmail",
            maxlength: 100,
            type: "input",
            placeholder: "请填写",
            required: false,
            rule: [
              {
                required: true,
                message: "请输入邮箱",
                trigger: "blur"
              },
              {
                pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                message: "请输入格式正确的邮箱"
              }
            ]
          },
          {
            label: "手机号码",
            value: "jLinkPhone",
            type: "input",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入联系电话",
                trigger: "blur"
              },
              {
                pattern: !/^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/gi,
                message: "输入的手机号码不正确！"
              }
            ]
          },
          {
            label: "验证码",
            value: "mimeCode",
            type: "slot",
            slotName: "mimeCode",
            required: true,
            rule: {
              required: true,
              message: "请输入验证码",
              trigger: "blur"
            }
          },
          {
            type: "slot",
            slotName: "tips"
          },
          {
            type: "slot",
            slotName: "btn"
          }
        ];
        // 清除表单验证和数据
        this.$refs.form.$refs.enInform.resetFields();
      } else if (tab.name === "3") {
        // 项目负责人申诉
        // 处理标识赋值
        this.clbs = "z";
        // 表单显示
        this.formConfigList = [
          {
            label: "项目负责人信息",
            class: "label"
          },
          {
            label: "姓名",
            value: "zPersonName",
            type: "input",
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入姓名",
                trigger: "blur"
              }
            ]
          },
          {
            label: "证件类型",
            value: "zIdCardTypeNum",
            type: "select",
            placeholder: "请选择",
            required: true,
            rule: {
              required: true,
              message: "请选择证件类型",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507052149470004"
            }
          },
          {
            label: "证件号码",
            value: "zIdCard",
            type: "input",
            maxlength: 25,
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入证件号码",
                trigger: "blur"
              }
            ]
          },
          {
            label: "申诉人信息",
            class: "label"
          },
          {
            label: "姓名",
            value: "zLinkMan",
            type: "input",
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入姓名",
                trigger: "blur"
              }
            ]
          },
          {
            label: "邮箱",
            value: "zLinkEmail",
            maxlength: 100,
            type: "input",
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入邮箱",
                trigger: "blur"
              },
              {
                pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                message: "请输入格式正确的邮箱"
              }
            ]
          },
          {
            label: "",
            type: "slot",
            slotName: "xmfzrTit"
          },
          {
            label: "手机号码",
            value: "zLinkPhone",
            type: "password",
            placeholder: "请填写",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入手机号码",
                trigger: "blur"
              },
              {
                pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: "输入的手机号码不正确！"
              }
            ]
          },
          {
            label: "验证码",
            value: "mimeCode",
            type: "slot",
            slotName: "mimeCode",
            required: true,
            rule: {
              required: true,
              message: "请输入验证码",
              trigger: "blur"
            }
          },
          {
            type: "slot",
            slotName: "tips"
          },
          {
            type: "slot",
            slotName: "btn"
          }
        ];
        // 清除表单验证和数据
        this.$refs.form.$refs.enInform.resetFields();
      }
    },
    /**
     * @author 任少杰
     * @description 提交
     */
    fun_InsUpd() {
      this.$refs.form.$refs.enInform.validate(valid => {
        if (valid) {
          // 如果为空
          if (this.controllerFlg == null || this.controllerFlg == "") {
            this.controllerFlg = "insert";
          }
          // 加密验证
          var code = "";
          // 如果处理标识是m
          if (this.clbs == "m") {
            // 密码找回
            // 1.登录名
            var mYhmc = this.form.mYhmc;
            mYhmc = window.RSAUtils.encryptedString(
              this.key,
              encodeURI(this.form.mYhmc)
            );
            // 2.联系人电子邮箱
            var mLxrdzyx = RSAUtils.encryptedString(
              this.key,
              this.form.mLxrdzyx
            );
            // 3.验证码
            var mMimeCode = RSAUtils.encryptedString(
              this.key,
              this.form.mimeCode
            );
            // 合并
            code = mYhmc + ";" + mLxrdzyx + ";" + mMimeCode;
          } else if (this.clbs == "j") {
            // 交易人申诉
            // 1.姓名
            var jLinkMan = this.form.jLinkMan;
            jLinkMan = window.RSAUtils.encryptedString(
              this.key,
              encodeURI(this.form.jLinkMan)
            );
            // 2.邮箱
            var jLinkEmail = RSAUtils.encryptedString(
              this.key,
              this.form.jLinkEmail
            );
            // 4.验证码
            var jMimeCode = RSAUtils.encryptedString(
              this.key,
              this.form.mimeCode
            );
            // 合并
            code = jLinkMan + ";" + jLinkEmail + ";" + jMimeCode;
          } else if (this.clbs == "z") {
            // 注册人申诉
            // 1.姓名
            var zLinkMan = this.form.zLinkMan;
            zLinkMan = window.RSAUtils.encryptedString(
              this.key,
              encodeURI(this.form.zLinkMan)
            );
            // 2.邮箱
            var zLinkEmail = RSAUtils.encryptedString(
              this.key,
              this.form.zLinkEmail
            );
            // 4.验证码
            var zMimeCode = RSAUtils.encryptedString(
              this.key,
              this.form.mimeCode
            );
            // 合并
            code = zLinkMan + ";" + zLinkEmail + ";" + zMimeCode;
          }
          this.code = code;
          // 设置遮罩
          this.fun_GetLoading();
          // 发起请求
          fun_PostAction("/corpBasicinfo/forgetPassword", {
            ...this.form,
            clbs: this.clbs,
            controllerFlg: this.controllerFlg,
            code: this.code,
            ssId: this.ssId
          })
            .then(res => {
              // 关闭遮罩
              this.fullLoading.close();
              // 结构res.data
              const { result, data, msg } = res.data;
              // 请求成功
              if (result) {
                // 关闭遮罩层
                this.loading = false;
                // 操作成功的场合
                if (data.result != null && data.result != "") {
                  // 消息不为空
                  if (data.rtnMsg != "") {
                    // 操作成功
                    this.$message({
                      type: "success",
                      duration: 0,
                      showClose: true,
                      message: data.rtnMsg
                    });
                  }
                  // 如果是企业申诉
                  if (this.clbs == "j") {
                    // 申诉表id不为空
                    if (data.ssId != "" && data.ssId != null) {
                      // 申诉表id不为空
                      this.ssId = data.ssId;
                      // 申诉表id不为空
                      if (this.ssId != "") {
                        // 定义流程标识
                        const sszz = {
                          label: "申诉证照",
                          class: "label"
                        };
                        // 定义流程标识
                        const zzsmj = {
                          label: "证照扫描件",
                          type: "slot",
                          slotName: "operation"
                        };
                        this.controllerFlg = "update";
                        // 是否存在证照扫描件
                        var zzFlag = false;
                        // 遍历
                        this.formConfigList.map((value, index) => {
                          // 如果存在证照扫描件
                          if (value.title === "证照扫描件") {
                            // 证照扫描件存在
                            zzFlag = true;
                          }
                        });
                        // 不存在时添加到表单中
                        if (!zzFlag) {
                          this.formConfigList.splice(12, 0, sszz);
                          this.formConfigList.splice(13, 0, zzsmj);
                        }
                      }
                    } else {
                      // 清空申诉表id
                      this.ssId = null;
                      // 清空
                      this.controllerFlg = null;
                      // 清除表单验证和数据
                      this.$refs.form.$refs.enInform.resetFields();
                      // 获取长度
                      let index = this.formConfigList.length;
                      // 遍历
                      while (index--) {
                        // 匹配申诉证照
                        if (this.formConfigList[index].label === "申诉证照") {
                          // 删除
                          this.formConfigList.splice(index, 1);
                        }
                        // 匹配证照扫描件
                        if (this.formConfigList[index].label === "证照扫描件") {
                          // 删除
                          this.formConfigList.splice(index, 1);
                        }
                      }
                    }
                  } // 如果是注册人申诉
                  else if (this.clbs == "z") {
                    // 申诉表id不为空
                    if (data.ssId != "" && data.ssId != null) {
                      // 申诉表id不为空
                      this.ssId = data.ssId;
                      // 申诉表id不为空
                      if (this.ssId != "") {
                        // 定义流程标识
                        const sszz = {
                          label: "申诉证照",
                          class: "label"
                        };
                        // 定义流程标识
                        const zzsmj = {
                          label: "证照扫描件",
                          type: "slot",
                          slotName: "operation"
                        };
                        this.controllerFlg = "update";
                        // 是否存在证照扫描件
                        var zzFlag = false;
                        // 遍历
                        this.formConfigList.map((value, index) => {
                          // 如果存在证照扫描件
                          if (value.title === "证照扫描件") {
                            // 证照扫描件存在
                            zzFlag = true;
                          }
                        });
                        // 不存在时添加到表单中
                        if (!zzFlag) {
                          this.formConfigList.splice(10, 0, sszz);
                          this.formConfigList.splice(11, 0, zzsmj);
                        }
                      }
                    } else {
                      // 清空申诉表id
                      this.ssId = null;
                      // 清空
                      this.controllerFlg = null;
                      // 清除表单验证和数据
                      this.$refs.form.$refs.enInform.resetFields();
                      // 获取长度
                      let index = this.formConfigList.length;
                      // 遍历
                      while (index--) {
                        // 匹配申诉证照
                        if (this.formConfigList[index].label === "申诉证照") {
                          // 删除
                          this.formConfigList.splice(index, 1);
                        }
                        // 匹配证照扫描件
                        if (this.formConfigList[index].label === "证照扫描件") {
                          // 删除
                          this.formConfigList.splice(index, 1);
                        }
                      }
                    }
                  }
                }
              } else {
                // 关闭遮罩层
                this.loading = false;
                // 提示请求失败的信息
                this.$message.error(msg);
              }
            })
            .catch(() => {
              // 失败
              // 关闭遮罩
              this.fullLoading.close();
            })
            .finally(() => {
              // 无论成败
              // 关闭遮罩
              this.fullLoading.close();
            });
        }
      });
    },
    /**
     * 全局遮罩方法
     */
    fun_GetLoading(val) {
      // 设置遮罩控件
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val : "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    /**
     * 查看文件
     */
    fun_GetPictureinfor(ssId) {
      // 打开弹窗
      this.$refs.corpPictureinfor.dialogVisible = true;
      // 赋值数据编号
      this.$refs.corpPictureinfor.form.recordNumber = ssId;
      // 打开弹框时调用
      this.$refs.corpPictureinfor.fun_GetOpen();
    }
  }
};
